import React, { useEffect, useMemo } from "react";
import "./NotificationBanner.scss";
import { NfirsFetchStatus, useNfirsGetData } from "../NFIRS/NFIRSHelper";
import ApsServices from "../../services";
import systemStore, { useSystemMessageTimer } from "../../stores/SystemStore";
import commonService from "../../services/CommonService";

const DISMISSED_SYSTEM_MESSAGE_KEY = "dismissed-system-message";

function NotificationBanner() {
  const tmo = useSystemMessageTimer();
  const message = useNfirsGetData(() => {
    return ApsServices.http.systemService.systemNotification();
  }, "System Notification");

  useEffect(() => {
    if (message.status !== NfirsFetchStatus.InProgress) {
      message.getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tmo]);

  const showBanner = useMemo(() => {
    if (
      message.data?.canBeDisplayed &&
      !commonService.isNullOrEmpty(message.data?.message || "") &&
      localStorage.getItem(DISMISSED_SYSTEM_MESSAGE_KEY) !== message.data?.id
    ) {
      return true;
    }
    return false;
  }, [message.data]);

  useEffect(() => {
    const onWindowResize = () => {
      const $el = document.getElementById("notification-banner");
      const height = $el?.clientHeight || 0;
      systemStore.setSystemBannerHeight(height);
    };
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const tmo = setTimeout(() => {
      const $el = document.getElementById("notification-banner");
      const height = $el?.clientHeight || 0;
      systemStore.setSystemBannerHeight(height);
    }, 200);
    return () => {
      clearTimeout(tmo);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showBanner]);

  return showBanner ? (
    <div id="notification-banner" className="notification-banner">
      <div className="flex flex-row flex-center">
        <div
          className="flex-1"
          dangerouslySetInnerHTML={{
            __html: `<i class="fa fa-exclamation-triangle me-2"></i> ${message.data?.message || ""}`,
          }}
        ></div>
        <div>
          <button type="button" className="btn btn-sm pointer">
            <i
              className="fa fa-times"
              title="Dismiss"
              onClick={(e) => {
                if (message.data?.id) {
                  localStorage.setItem(
                    DISMISSED_SYSTEM_MESSAGE_KEY,
                    message.data?.id || "",
                  );
                  message.setDataAndComplete(undefined);
                  systemStore.setSystemBannerHeight(0);
                }
              }}
            ></i>
          </button>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}

export default NotificationBanner;
